import { CloudStore } from "@omni/types/api/store/cloud/store.model";

import { GetStoreStrategy } from "@/services/store.service";

export const $PreferredStoreModuleName = "preferredStore";

export type TGetPreferredStoreByCodeRequest = {
    code: string;
    strategy: GetStoreStrategy;
    sku?: string;
};

export type TPreferredStoreState = CloudStore & Record<string, CloudStore>;
